import Cookies from "js-cookie";
import { fireEvent } from "@/scripts/common/util";
import { createValidator } from "@/scripts/components/form/validation/validator";
import delegate from "delegate-it";
import "./consumers-participants.css";

document.addEventListener("DOMContentLoaded", () => {
  const modalUrl = window.__APP__.disclaimerModalUrl;

  if (!modalUrl) {
    return;
  }

  fireEvent("modal:open", document.documentElement, {
    type: "content",
    url: modalUrl,
    allowOverlayClose: false,
    allowButtonClose: false,
  });

  const handleModalForm = (e) => {
    const form = e.detail.modalEl.querySelector("form");
    const validator = createValidator(form);

    form.addEventListener("submit", (e) => {
      e.preventDefault();

      const result = validator.validateForm();

      if (result.isValid) {
        Cookies.set("app_cp_disclaimer_seen", "true", { expires: 1 });
        fireEvent("modal:close", document.documentElement);
      }
    });
  };

  delegate("html", "modal:populate", handleModalForm);
});
